/**
 * Ani JavaScript
 *
 * This file defines behaviors of
 * ani blocks.
 */

// import animations
import { aniScroll } from './scripts/aniScroll';
import { ani, aniDelegate } from './scripts/aniViewport';

// execute animations
aniScroll({
	parent: '.ani--parallax',
	child: '.ani-child--parallax',
});
ani([
	...aniDelegate([{ parent: '.ani-parent', child: '.ani-child' }]),
	...document.querySelectorAll('.ani'),
]);
